(() => {
  const initialized = new WeakSet();
  const touchLayout = matchMedia('(max-width:999px)');
  function init() {
    const header = document.querySelector('[data-os-header]');
    if (!header || initialized.has(header)) return;
    initialized.add(header);
    const menu = header.querySelector('[data-os-menu]');
    const dialog = document.getElementById('OsMobileMenu');
    const triggers = [...header.querySelectorAll('[data-os-department]')];
    const panels = [...header.querySelectorAll('[data-os-department-panel]')];
    const summary = menu.querySelector('summary');
    let selected = '0';
    let closeTimer;
    let returnFocus;
    const sync = () => triggers.forEach(button => button.setAttribute('aria-expanded', String(menu.open && button.dataset.osDepartment === selected)));
    const closeDesktop = () => { clearTimeout(closeTimer); menu.open = false; sync(); };
    const select = (index, open = true) => {
      if (touchLayout.matches) return;
      clearTimeout(closeTimer);
      selected = index;
      panels.forEach(panel => { panel.hidden = panel.dataset.osDepartmentPanel !== selected; });
      if (open) menu.open = true;
      const top = header.getBoundingClientRect().bottom;
      header.style.setProperty('--os-menu-top', `${Math.max(0, top)}px`);
      sync();
    };
    const openMobile = (opener) => {
      closeDesktop();
      if (!dialog || dialog.open) return;
      returnFocus = opener;
      dialog.showModal();
      document.body.classList.add('os-menu-open');
      dialog.querySelector('[data-os-close-menu]').focus();
    };
    triggers.forEach(button => {
      button.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') select(button.dataset.osDepartment); });
      button.addEventListener('click', () => select(button.dataset.osDepartment));
      button.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          select(button.dataset.osDepartment);
          panels.find(panel => !panel.hidden)?.querySelector('a')?.focus();
        }
      });
    });
    summary.addEventListener('click', event => {
      if (touchLayout.matches) { event.preventDefault(); openMobile(summary); }
    });
    menu.addEventListener('toggle', () => { if (menu.open) select(selected, false); else sync(); });
    header.addEventListener('pointerenter', () => clearTimeout(closeTimer));
    header.addEventListener('pointerleave', event => {
      if (event.pointerType === 'mouse' && !header.contains(document.activeElement)) closeTimer = setTimeout(closeDesktop, 220);
    });
    header.addEventListener('focusout', () => { requestAnimationFrame(() => { if (!header.contains(document.activeElement)) closeDesktop(); }); });
    document.querySelectorAll('[data-os-open-menu]').forEach(button => button.addEventListener('click', () => openMobile(button)));
    dialog?.querySelector('[data-os-close-menu]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', event => {
      if (event.target === dialog || event.target.closest('a')) dialog.close();
    });
    dialog?.addEventListener('close', () => {
      document.body.classList.remove('os-menu-open');
      returnFocus?.focus();
    });
    dialog?.querySelectorAll('[data-os-mobile-department]').forEach(department => {
      department.addEventListener('toggle', () => {
        if (department.open) dialog.querySelectorAll('[data-os-mobile-department]').forEach(other => { if (other !== department) other.open = false; });
      });
    });
    document.addEventListener('click', event => { if (!header.contains(event.target)) closeDesktop(); });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu.open) { closeDesktop(); summary.focus(); }
    });
    touchLayout.addEventListener('change', () => { closeDesktop(); if (!touchLayout.matches) dialog?.close(); });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
